// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"180":"54902e778cdf9bec3af9","788":"a295738f3e6dc4b21f4a","999":"c0498be6f2482141e6a2"}[chunkId] + ".css";
};